import React from "react";

const Testimonials = () => {
  const testimonials = [
    {
      name: "Rahul",
      text: "Working with SecurXperts felt like having our own internal security team. They explained everything clearly and fixed our issues without any confusion. We finally feel safe online.",
    },
    {
      name: "Satish",
      text: "We were struggling with compliance, then we approached SecurXperts they made the whole process so easy. Their team was patient, friendly and guided us step by step. Truly grateful for their support.",
    },
    {
      name: "Ram",
      text: "The SecurXperts team took the time to understand our business needs. They didn’t rush anything. Their cloud security setup works perfectly for us now.",
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-white relative overflow-hidden">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/circuit-board.png')] opacity-5"></div>

      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-blue-600 font-semibold text-sm uppercase mb-2 tracking-wide">
          Client Review
        </p>
        <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-12">
          What Our Clients Say
        </h2>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((item, index) => (
            <div
              key={index}
              className="bg-gray-50 border border-gray-100 shadow-sm hover:shadow-lg transition-all rounded-2xl p-6 flex flex-col justify-between relative"
            >
              <p className="text-gray-700 text-base leading-relaxed mb-8">
                {item.text}
              </p>

              {/* Profile Info */}
              <div className="flex items-center gap-3 mt-auto">
                <div className="text-left">
                  <h4 className="font-bold text-gray-900 text-lg">
                    {item.name}
                  </h4>
                  <p className="text-sm text-gray-500">{item.role}</p>
                </div>
              </div>

              {/* Quotation mark decoration */}
              <div className="absolute bottom-1 right-1 bg-blue-900 text-white rounded-tl-3xl rounded-br-2xl p-3">
                <span className="text-4xl leading-none font-serif">“</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
